import { createStore } from "@react-pdf-viewer/core";
import { useMemo } from "react";

const useCustomZoomPlugin = () => {
    const store = useMemo(() => createStore({}), []);

    return {
        install: (pluginFunctions) => {
            store.update('zoom', pluginFunctions.zoom);
        },
        zoomTo: (scale) => {
            const zoom = store.get('zoom');
            if (zoom) {
                // Zoom to that scale
                zoom(scale);
            }
        }
    };
};

export default useCustomZoomPlugin;